module.exports = __webpack_public_path__ + "img/covid19.c94b18aa.png";